import { useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import type { CguAcceptanceResult } from '@/api/legal-client';
import { CguScreen } from '@/routes/cgu/cgu-screen';

// =============================================================================
// cgu-route.tsx — Adaptateur routeur de l'écran F-02 (signature CGU).
// =============================================================================
// Après signature réussie, route vers le tableau de bord fournisseur (§3.2,
// « /dashboard ») — JAMAIS « / » (landing/auth ADMIN, §2.1 l.514/574 — séparation
// ferme des mondes, §1.3 l.374). La présentation et la garde d'intentionnalité
// par lecture vivent dans CguScreen (testable hors routeur) ; cet adaptateur ne
// porte que la navigation.

export function CguRoute(): React.JSX.Element {
  const navigate = useNavigate();

  const onSigned = React.useCallback(
    (_result: CguAcceptanceResult): void => {
      void navigate({ to: '/dashboard' });
    },
    [navigate],
  );

  return <CguScreen onSigned={onSigned} />;
}
